import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'
/**
 * When a an apply request is made, plugin attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const applyRulesOnRequest = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.apply.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: plugin.collection.feature.selectors.context.asObservable,
      })),
      rxjs.mergeMap(({ action, context }) =>
        plugin.api.apply(context).pipe(
          // Handles success
          rxjs.map(() => feature.actions.apply.success.from(action).create()),
          // Can only succeed once
          rxjs.take(1),
          // Handles error
          rxjs.catchError(error =>
            rxjs.of(feature.actions.apply.error.from(action).create({ error })),
          ),
        ),
      ),
    ),
)
